export const ADD_TO_CART = 'add_to_cart'
export const PRODUCT = 'product'
export const BUYBACK_DEVICE_SPECIFICATIONS = 'buyback_device_specifications'
export const SEARCH_TERM = 'search_term'
export const FAVORITES_PAGE_VIEW = 'favorites_page_viewed'
export const ADDED_TO_FAVORITES = 'added_to_favorites'
